<script>
import { mapGetters } from "vuex";
import RichText from "@/components/ui/RichText.vue";

export default {
  name: "Bahn1WichtigsteImpulse",
  components: { RichText },
  computed: {
    ...mapGetters("bahn1", ["wichtigstenImpulse"]),
    impulses() {
      if (!Array.isArray(this.wichtigstenImpulse)) return [];
      return this.wichtigstenImpulse
        .reduce((acc, group) => {
          return group && Array.isArray(group.Impulse)
            ? acc.concat(group.Impulse)
            : acc;
        }, [])
        .filter(item => item && item.ImpulseText);
    }
  }
};
</script>

<template>
  <div class="impulses" v-if="impulses.length">
    <h2 class="impulses-heading">Die wichtigsten Impulse</h2>

    <div class="impulse-item" v-for="(impulse, index) in impulses" :key="index">
      <div class="impulse">
        <span class="impulse-index">{{ index + 1 }}</span>
        <RichText class="impulse-text" :markdown-text="impulse.ImpulseText" />
      </div>
      <div v-if="index < impulses.length - 1" class="impulse-separator"></div>
    </div>
  </div>
</template>

<style scoped>
.impulses-heading {
  margin-top: 56px;
  font-size: 30px;
  letter-spacing: 0.6px;
}
.impulse {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin: 16px 0;
}
.impulse-index {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #004ba0;
  color: #ffffff;
  font-family: "GeometriaMedium", sans-serif;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.impulse-text {
  flex: 1;
  font-family: "GeometriaLight";
}
.impulse-separator {
  height: 2px;
  margin-left: 56px;
  background: #e4e4e4;
}
</style>
